import { action, observable } from 'mobx';

interface AvailableExcessOrOrphanModel {
  available_weight: number;
  grade: string;
  ico_identifier: string;
  alternative_ico_identifier: string;
  id: number;
  identifier: string;
  location: { area?: string; level?: string; bin?: string; position?: string };
  mark?: string;
  quality: string;
}

class AvailableExcessOrOrphanItemModel {
  public attributes: AvailableExcessOrOrphanModel;

  @observable public quantity: string;
  @observable public selected: boolean;
  @observable public finalAvailableWeight: number;

  constructor(item: AvailableExcessOrOrphanModel) {
    this.attributes = item;
    this.selected = false;
    this.quantity = item.available_weight.toString();
    this.quantity = parseFloat(this.quantity).toFixed(2).toString();
    this.finalAvailableWeight = parseFloat(this.quantity);
  }

  @action public setQuantity = (newQuantity: string) => {
    // Never allow using more than what's actually available (net of other milling orders'
    // reservations). If the user types more, clamp it to the available quantity.
    const parsed = parseFloat(newQuantity);
    if (!isNaN(parsed) && parsed > this.finalAvailableWeight) {
      this.quantity = this.finalAvailableWeight.toFixed(2).toString();
    } else {
      this.quantity = newQuantity;
    }
  };

  @action public formatQuantity = () => {
    const parsed = parseFloat(this.quantity);
    if (!isNaN(parsed)) {
      this.quantity = parsed.toFixed(2).toString();
    }
  };
  @action public updateAvailableWeight = (newWeight: number) => {
    this.attributes.available_weight = parseFloat(newWeight.toFixed(2));
  };
  @action public setFinalAvailableWeight = (newWeight: number) => {
    this.finalAvailableWeight = parseFloat(newWeight.toFixed(2));
  };
  @action public setSelected = (selected: boolean) => {
    this.selected = selected;
  };
}

export default AvailableExcessOrOrphanItemModel;
